function BoardsTab({ boards }) {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Quản lý Boards</h2>
        <p className="text-gray-600 dark:text-gray-400">Tổng quan về các bảng và tags</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {boards.map(board => {
          const boardInfo = board.boardInfo?.[0] || {};
          return (
            <div 
              key={board._id} 
              className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 hover:shadow-xl transition-all hover:-translate-y-1"
            >
              {/* Header */}
              <div className="flex items-start gap-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">
                  {boardInfo.icon || '📌'}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-gray-900 dark:text-white truncate">
                    {boardInfo.name || 'Unknown'}
                  </h4>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {boardInfo.pinCount || board.count || 0} prompts
                  </p>
                </div>
              </div>

              {/* Stats */}
              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    <span className="material-symbols-rounded text-[16px]">visibility</span>
                    Views
                  </span>
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {board.totalViews || 0}
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    <span className="material-symbols-rounded text-[16px]">favorite</span>
                    Likes
                  </span>
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {board.totalLikes || 0}
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                    <span className="material-symbols-rounded text-[16px]">trending_up</span>
                    Avg Views
                  </span>
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {board.count > 0 ? Math.round(board.totalViews / board.count) : 0}
                  </span>
                </div>
              </div>

              {/* Tags */}
              {boardInfo.tags && boardInfo.tags.length > 0 && (
                <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                  <p className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2">
                    Tags ({boardInfo.tags.length})
                  </p>
                  <div className="flex flex-wrap gap-1">
                    {boardInfo.tags.slice(0, 5).map((tag, idx) => (
                      <span 
                        key={idx}
                        className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium"
                      >
                        #{tag}
                      </span>
                    ))}
                    {boardInfo.tags.length > 5 && (
                      <span className="px-2 py-1 text-gray-500 dark:text-gray-400 text-xs">
                        +{boardInfo.tags.length - 5}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BoardsTab;
